import React, { useState , } from 'react';
import TableViewBox from './ViewBox1.jsx'
import { FaBook, FaPlus } from 'react-icons/fa';
import { MdLibraryAdd } from 'react-icons/md';
const DropdownRow = () => {
  const listOne = ['lib1','lib2','lib3'];
  const listTwo = ['show books','show librarians'];

  const [selectedOne, setSelectedOne] = useState('');
  const [selectedTwo, setSelectedTwo] = useState('');

  const data = [
    { id: 1, name: 'Alice', role: 'Teacher' },
    { id: 2, name: 'Bob', role: 'Student' },
    { id: 2, name: 'Bob', role: 'Student' },
    { id: 2, name: 'Bob', role: 'Student' },
    { id: 2, name: 'Bob', role: 'Student' },
    { id: 2, name: 'Bob', role: 'Student' },
    { id: 2, name: 'Bob', role: 'Student' },
    { id: 2, name: 'Bob', role: 'Student' },
    // ... more entries
  ];

  const handleAction = () => {
    alert(`Selected: ${selectedOne} and ${selectedTwo}`);
  };

  return (
    <div
    style={{
      display: 'flex',
      gap: '16px',
      padding: '10px',
      flexDirection: 'column' ,
      backgroundColor: '#f9f9f9',
      height: '92vh', // locks height to window height
      overflow: 'auto', // optional: allows scrolling if content exceeds
      borderRadius: '20px'
    }}>

    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '50px',
        backgroundColor: '#f9f9f9',
        maxWidth: '100%',
        flexWrap: 'wrap'
      }}
    >
      <select
        value={selectedOne}
        onChange={(e) => setSelectedOne(e.target.value)}
        style={{ padding: '10px', borderRadius: '8px', minWidth: '150px' }}
      >
        <option value="">Select from list one</option>
        {listOne.map((item, index) => (
          <option key={index} value={item}>{item}</option>
        ))}
      </select>

      <select
        value={selectedTwo}
        onChange={(e) => setSelectedTwo(e.target.value)}
        style={{ padding: '10px', borderRadius: '8px', minWidth: '150px' }}
      >
        <option value="">Select from list two</option>
        {listTwo.map((item, index) => (
          <option key={index} value={item}>{item}</option>
        ))}
      </select>

      <button
        onClick={handleAction}
        style={{
          padding: '10px 20px',
          borderRadius: '8px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        Run Action
      </button>

    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '24px' }}>
        <MdLibraryAdd size={24} style={{ cursor: 'pointer' }} />
    </div>

    </div>
      <TableViewBox data = {data} />
    </div>
  );
};

export default DropdownRow;
